"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffAccessKeys = void 0;
exports.staffHasAnyAccess = staffHasAnyAccess;
exports.staffHasAllAccess = staffHasAllAccess;
exports.staffHasOnlyStaffAccess = staffHasOnlyStaffAccess;
const interface_1 = require("../interface");
exports.StaffAccessKeys = Object.keys(interface_1.StaffAccess).map((key) => ({
    key,
    value: interface_1.StaffAccess[key],
}));
function staffHasAnyAccess({ currentAccess, expectedAccess, }) {
    const alwaysAllowedAccess = [interface_1.StaffAccess.CEO, interface_1.StaffAccess.Manager];
    if (currentAccess.some((access) => alwaysAllowedAccess.includes(access))) {
        return true;
    }
    if (expectedAccess.includes(interface_1.StaffAccess.All)) {
        return true;
    }
    return expectedAccess.some((access) => currentAccess.includes(access));
}
function staffHasAllAccess({ currentAccess, onlyAccess, }) {
    return onlyAccess.every((access) => currentAccess.includes(access));
}
function staffHasOnlyStaffAccess(currentAccess) {
    if (currentAccess.length === 1) {
        if (currentAccess[0] === interface_1.StaffAccess.Staff)
            return true;
    }
    return false;
}
//# sourceMappingURL=staff.js.map